const getPattern = (field) => {
  switch (field) {
    case 'phoneNumber':
      return /^([+]{1}|\d+|[+]{1}\d+)$/;
    case 'houseNumber':
      return /^[1-9]\d*(?:[/]?(?:[a-zA-Z]?))?$/;
    case 'zipCode':
    case 'floor':
    case 'door':
      return /^\d+$/;
    case 'birthYear':
      return /^\d{0,4}$/;
    case 'lastName':
    case 'firstName':
    case 'birthLastName':
    case 'birthFirstName':
    case 'motherBirthLastName':
    case 'motherBirthFirstName':
    case 'birthPlace':
      return /^[A-Za-zÁÉŰÚŐÓÜÖÍáéűúőóüöí .-]*$/;
    default:
      return null;
  }
};

export default getPattern;
